import baguetteBox from 'baguettebox.js/dist/baguetteBox';

/**
 * @file Simple lightbox module
 *
 * @author christian.sany@notch-interactive.com
 */

const instance = {},
    defaults = {
        baguetteContainer: '.lightbox-gallery, .simple-lightbox'
    },
    settings = {};

/**
 * Initialize module
 *
 * @param {object} options - Override default settings with options object.
 * @return {object} Instance of created module.
 */

instance.init = (options) => {
    Object.assign(settings, defaults, options);

    baguetteBox.run(settings.baguetteContainer, {
        async: true,
        filter: /.+\.(gif|jpe?g|png|webp|htm)/i
    });

    return instance;
};

export default instance;
